function isPrivateDevHost(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(hostname)
  );
}

export function getPortalUrl(override?: string): string {
  if (override) return override.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.PORTAL_AUTH_URL) {
    return window.PORTAL_AUTH_URL.replace(/\/$/, "");
  }
  if (typeof window !== "undefined") {
    const { hostname, protocol } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:3100";
    }
    if (isPrivateDevHost(hostname)) {
      return `${protocol}//${hostname}:3100`;
    }
  }
  if (typeof import.meta !== "undefined" && import.meta.env?.VITE_PORTAL_URL) {
    return String(import.meta.env.VITE_PORTAL_URL).replace(/\/$/, "");
  }
  return "https://portal.interactggz.nl";
}
